import React from 'react';
import { RotateCcw, Target, Calendar, Rocket, ArrowRight } from 'lucide-react';
interface QuickActionsProps {
  onStartDaily: () => void;
  onStartReview: () => void;
  onStartSimulator: () => void;
  onStartPlacement?: () => void;
}
export function QuickActions({
  onStartDaily,
  onStartReview,
  onStartSimulator,
  onStartPlacement
}: QuickActionsProps) {
  return <div data-id="element-452">
      <h2 className="text-lg font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-453">
        <Rocket className="w-5 h-5 text-indigo-600" data-id="element-454" />
        Snel aan de slag
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-455">
        {/* Primary Action - Daily Practice */}
        <button onClick={onStartDaily} className="md:col-span-3 flex items-center justify-between p-5 bg-indigo-600 rounded-2xl shadow-md shadow-indigo-200 hover:bg-indigo-700 hover:shadow-lg transition-all group text-white relative overflow-hidden" data-id="element-456">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-10 -mt-10 blur-2xl transition-transform group-hover:scale-150 duration-700" data-id="element-457"></div>

          <div className="flex items-center gap-4 relative z-10" data-id="element-458">
            <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center text-white backdrop-blur-sm" data-id="element-459">
              <Calendar className="w-6 h-6" data-id="element-460" />
            </div>
            <div className="text-left" data-id="element-461">
              <div className="font-bold text-lg" data-id="element-462">Dagelijkse Oefening</div>
              <div className="text-indigo-100 text-sm opacity-90" data-id="element-463">
                Start een mix van alle vakken
              </div>
            </div>
          </div>

          <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white group-hover:text-indigo-600 transition-colors relative z-10" data-id="element-464">
            <ArrowRight className="w-5 h-5" data-id="element-465" />
          </div>
        </button>

        {/* Secondary Actions */}
        <button onClick={onStartReview} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-slate-200/60 shadow-sm hover:shadow-md hover:border-amber-200 transition-all text-left group" data-id="element-466">
          <div className="w-10 h-10 rounded-lg bg-amber-50 flex items-center justify-center text-amber-600 group-hover:scale-110 transition-transform" data-id="element-467">
            <RotateCcw className="w-5 h-5" data-id="element-468" />
          </div>
          <div data-id="element-469">
            <span className="block font-bold text-sm text-slate-700 group-hover:text-slate-900" data-id="element-470">
              Fouten Herstellen
            </span>
            <span className="text-xs text-slate-400" data-id="element-471">Oefen wat lastig was</span>
          </div>
        </button>

        <button onClick={onStartPlacement} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-slate-200/60 shadow-sm hover:shadow-md hover:border-emerald-200 transition-all text-left group" data-id="element-472">
          <div className="w-10 h-10 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-600 group-hover:scale-110 transition-transform" data-id="element-473">
            <Rocket className="w-5 h-5" data-id="element-474" />
          </div>
          <div data-id="element-475">
            <span className="block font-bold text-sm text-slate-700 group-hover:text-slate-900" data-id="element-476">
              Extra Niveaucheck
            </span>
            <span className="text-xs text-slate-400" data-id="element-477">Bepaal je niveau</span>
          </div>
        </button>

        <button onClick={onStartSimulator} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-slate-200/60 shadow-sm hover:shadow-md hover:border-indigo-200 transition-all text-left group" data-id="element-478">
          <div className="w-10 h-10 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600 group-hover:scale-110 transition-transform" data-id="element-479">
            <Target className="w-5 h-5" data-id="element-480" />
          </div>
          <div data-id="element-481">
            <span className="block font-bold text-sm text-slate-700 group-hover:text-slate-900" data-id="element-482">
              CITO Simulator
            </span>
            <span className="text-xs text-slate-400" data-id="element-483">Oefen voor de toets</span>
          </div>
        </button>
      </div>
    </div>;
}